import { type Dict } from "../@types/Dict";

export const subordinateComponents = <T, U extends Dict>(
  root: T,
  fragments: U,
) => {
  Object.entries(fragments).map(([key, fragment]) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-assignment
    root[key as keyof T] = fragment as any;
  });
  return root as unknown as T & U;
};
